/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import { simpleFetch } from "../../../restWrapper.js";
import { renderErrorMsg } from "../../../assets/component/renderErrorMsg.js";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PropTypes from "prop-types";
import Promise from "bluebird";
import { NumericFormat } from "react-number-format";
import ToggleSwitch from "../../../assets/component/ToggleSwitch/ToggleSwitch.js";
import PayoutHistoryTable from './PayoutHistoryTable';

class RenderStripe extends Component {
  constructor(props) {
    super(props);
    let open = new Date();
    open.setHours(0, 0, 0, 0);
    let end = new Date();
    end.setHours(23, 59, 59, 59);

    this.state = {
      loading: true,
      bankAc: [],
      errMsgPayout: {
        selecAc: "",
      },
      balance: 0,
      payoutAmount: 0,
      payoutsRecord: {
        data: [],
        loading: false,
        lastId: "",
        hasMore: false,
      },
      startDate: open,
      endDate: end,
    };
  }

  componentDidMount() {
    Promise.all([
      this.getBankList(),
      this.getBalance(),
      this.getStripeKyc(),
      this.getStripeAccountLink(),
      this.getStripeStatus(),
    ]).then((res) => {
      for (var i = 0; i < res.length; i++) {
        if (res[i].status === 413) {
          this.setState({
            blocked: true,
            loading: false,
          });
          return null;
        }
      }
      this.setState({
        loading: false,
        blocked: false,
      });
    });
  }

  /* Get Stripe Account Link */
  getStripeAccountLink() {
    return simpleFetch("/organizations/createAccountLink", "GET").then(
      (res) => {
        if (res.body.url) {
          this.setState({
            stripeAccountLink: res.body.url,
          });
        }
        return res;
      }
    );
  }

  /* Get KYC status */
  getStripeKyc() {
    return simpleFetch("/organizations/StripeKYCStatus", "GET").then((res) => {
      if (res.status !== 200) return false;
      if (res.body.requirements) {
        if (res.body.requirements.currently_due) {
          this.setState({
            currently_due: res.body.requirements.currently_due,
          });
        }

        if (res.body.requirements.eventually_due) {
          this.setState({
            eventually_due: res.body.requirements.eventually_due,
          });
        }

        if (res.body.requirements.past_due) {
          this.setState({
            past_due: res.body.requirements.past_due,
          });
        }

        if (
          res.body.requirements.currently_due ||
          res.body.requirements.eventually_due ||
          res.body.requirements.past_due
        ) {

          if (
            res.body.requirements.currently_due.length +
              res.body.requirements.eventually_due.length +
              res.body.requirements.past_due.length >
            0
          ) {
            this.setState({
              kyc:
                res.body.requirements.currently_due.length +
                res.body.requirements.eventually_due.length +
                res.body.requirements.past_due.length,
            });
          }
        }
      }
      return res;
    });
  }

  getStripeStatus() {
    return simpleFetch("/organizations/retrieveCapability", "GET").then(
      (res) => {
        if (res.status === 200) {
          this.setState({
            cardPaymentsStatus: res.body.cardPaymentsStatus,
            transfersStatus: res.body.transfersStatus,
          });
        }
        return res;
      }
    );
  }

  getBalance() {
    return simpleFetch("/organizations/balance", "GET").then((res) => {
      if (res.status !== 200) return res;
      this.setState({
        balance: res.body.available[0],
      });
      return res;
    });
  }

  getBankList() {
    return simpleFetch("/organizations/banks", "GET").then((res) => {
      if (res.status !== 200) {
        return res;
      } else {
        // Make sure res.body.data exists before setting state
        if (res.body && res.body.data && Array.isArray(res.body.data)) {
          this.setState({
            bankAc: res.body.data,
          });
        } else if (res.body && Array.isArray(res.body)) {
          // Fallback if the response doesn't have a data property
          this.setState({
            bankAc: res.body,
          });
        } else {
          // console.error("Invalid bank list format:", res.body);
          this.setState({
            bankAc: [],
          });
        }
      }
      return res;
    }).catch(err => {
      // console.error("Failed to fetch bank list:", err);
      return { status: 500, error: err.message };
    });
  }

  render() {
    const textObj = this.props.languageObj;

    if (this.state.loading) {
      return (
        <div className="OrgPayout-emptyPage">
          <div className="OrgPayout-center">
            <div className="OrgPayout-btm-load"></div>
          </div>
        </div>
      );
    }
    const _payoutInput = (e) => {
      let amount = e.target.value;

      let amountSplit = amount.split("$");
      if (!amountSplit[1]) return false;
      amountSplit = amountSplit[1].split(",");

      let a = "";
      for (var i = 0; i < amountSplit.length; i++) {
        a += amountSplit[i];
      }
      let err = this.state.errMsgPayout;
      err.amount = "";
      const numberAmount = Number(a);

      this.setState({
        payoutAmount: numberAmount,
        errMsgPayout: err,
      });
    };

    const submitBtn = (e) => {
      if (this.state.loading) return false;

      let a = this.state.payoutAmount;
      const err = textObj.payoutErr;
      let errMsg = this.state.errMsgPayout;

      if (a > this.state.balance) {
        errMsg.amount = err.maxAmount;
      }

      if (a < 1) {
        errMsg.amount = err.amount;
        this.setState({ errMsgPayout: errMsg });
        return false;
      }

      let acId;
      let data = this.state.bankAc;

      for (var i = 0; i < data.length; i++) {
        if (data[i].clicked) {
          acId = data[i].id;
        }
      }

      if (!acId) {
        errMsg.selecAc = err.selecAc;
        this.setState({ errMsgPayout: errMsg });
        return false;
      }

      this.setState({ loading: true });

      simpleFetch("/organizations/StripeKYCStatus", "GET").then((res) => {
        if (res.status === 200) {
          if (res.body.verification.disabled_reason === "fields_needed") {
            this.props.history.push({ pathname: "/KycForm" });
          } else {
            simpleFetch("/organizations/payouts", "POST", {
              bankId: acId,
              amount: a,
              currency: "hkd",
            }).then((res) => {
              this.setState({ loading: false });
              if (res.status !== 204) {
                errMsg.amount = err.payoutFail;
                this.setState({ errMsgPayout: errMsg });
              } else {
                this.props.history.push({ pathname: "/PayoutSuccess" });
              }
            });
          }
        } else {
          this.setState({ errMsgPayout: err.payoutFail, loading: false });
        }
      });
    };

    const renderOrgBankAc = (ac) => {
      if (!ac) return;

      const onDelete = () => {
        this.setState({ loading: true });
        let bankInfo = this.state.bankAc;
        for (var i = 0; i < bankInfo.length; i++) {
          if (bankInfo[i].id === ac.id) {

            simpleFetch("/organizations/banks/deleteBank", "POST", {
              bankId: bankInfo[i].id,
              stripeAccountId: bankInfo[i].account,
            }).then((res) => {
              if ((res.body.deleted = true)) {
                this.setState({ loading: false });
                //this.props.history.push({ pathname: "/OrgPayout" });
                window.location.reload(true);
              }
            });
          }
        }
      };

      const onSetDefault = () => {
        this.setState({ loading: true });
        let bankInfo = this.state.bankAc;
        for (var i = 0; i < bankInfo.length; i++) {
          if (bankInfo[i].id === ac.id) {

            simpleFetch("/organizations/banks/updateBankAccount", "POST", {
              bankId: bankInfo[i].id,
              stripeAccountId: bankInfo[i].account,
            }).then((res) => {
              if ((res.body.deleted = true)) {
                this.setState({ loading: false });
                //this.props.history.push({ pathname: "/OrgPayout" });
                window.location.reload(true);
              }
            });
          }
        }
      };

      const key = ac.bank_name + ac.last4;

      return (
        <div className="OrgPayout-frame" key={key}>
          <div className="OrgPayout-toolbar">
            <div onClick={onDelete} className="OrgPayout-deleteBtn">
              <div className="OrgPayout-deleteIcn" />
            </div>

            {ac.default_for_currency === true ? (
              <div className="OrgPayout-defaultBtn">
                <div className="OrgPayout-defaultIcn">Default</div>
              </div>
            ) : (
              <div onClick={onSetDefault} className="OrgPayout-setDefaultBtn">
                <div className="OrgPayout-setDefaultIcn">Set to Default</div>
              </div>
            )}
          </div>

          <div className="OrgPayout-currency">
            <div className="OrgPayout-currencyText">
              {ac.currency.toUpperCase()}
            </div>
          </div>
          <div className="OrgPayout-text">
            <div className="OrgPayout-title">
              Bank
              <br />
              Account number
              <br />
              Account holder
            </div>
            <div className="OrgPayout-data">
              {ac.bank_name}
              <br />
              {ac.routing_number} •••• {ac.last4}
              <br />
              {ac.account_holder_name}
            </div>
          </div>
        </div>
      );
    };

    const handleChange = (name, e) => {
      let payoutsRecord = this.state.payoutsRecord;
      payoutsRecord.hasMore = false;
      payoutsRecord.lastId = "";
      this.setState({
        [name]: e,
        payoutsRecord: payoutsRecord,
      });
      if (e < this.state.startDate && name === "endDate") {
        this.setState({
          startDate: e,
        });
      }
    };

    const activate3DS = () => {
      this.setState({
        loading: true,
      });
      simpleFetch("/organizations/updateCapability", "GET").then((res) => {
        if (res.status === 200) {
          window.location.reload();
        }
      });
    };

    const clickPayoutDateBtn = () => {
      if (this.state.payoutsRecord.loading || this.state.loading) return false;

      const moment = require("moment");

      const startDate = moment(this.state.startDate).toISOString(false);
      const endDate = moment(this.state.endDate).toISOString(false);

      let obj = {
        startDate: startDate,
        endDate: endDate,
      };
      let payoutsRecord = this.state.payoutsRecord;
      const lastId = payoutsRecord.lastId;
      if (lastId) {
        obj.lastId = lastId;
      }
      payoutsRecord.loading = true;
      this.setState({
        payoutsRecord: payoutsRecord,
      });
      
      simpleFetch("/organizations/listPayout", "GET", obj)
        .then((res) => {
          payoutsRecord.loading = false;
          
          if (res.status === 200) {
            // Check if res.body exists and has the expected structure
            if (!res.body) {
              // console.error("Invalid response format: missing body");
              let errMsg = this.state.errMsgPayout;
              errMsg.payoutData = "Error loading payout data";
              this.setState({
                errMsgPayout: errMsg,
                payoutsRecord: payoutsRecord,
              });
              return;
            }
            
            // Ensure data property exists and is an array
            if (!res.body.data) {
              res.body.data = [];
            }
            
            if (!Array.isArray(res.body.data)) {
              // console.error("Invalid response format: data is not an array");
              res.body.data = [];
            }
            
            if (res.body.data.length < 1) {
              let errMsg = this.state.errMsgPayout;
              errMsg.payoutData = "No data for the selected date range";
              this.setState({
                errMsgPayout: errMsg,
                payoutsRecord: payoutsRecord,
              });
              return;
            } else {
              let errMsg = this.state.errMsgPayout;
              errMsg.payoutData = null;
              this.setState({
                errMsgPayout: errMsg,
              });
            }
            
            if (!lastId) {
              payoutsRecord.data = res.body.data;
            } else {
              payoutsRecord.data.push(...res.body.data);
            }
            
            payoutsRecord.hasMore = res.body.has_more || false;
            
            if (payoutsRecord.hasMore && payoutsRecord.data.length > 0) {
              const dataObj = payoutsRecord.data;
              payoutsRecord.lastId = dataObj[dataObj.length - 1].id;
            } else {
              payoutsRecord.lastId = "";
            }
          } else {
            // Handle non-200 responses
            // console.error("Error fetching payout data:", res);
            let errMsg = this.state.errMsgPayout;
            
            if (res.body && res.body.message) {
              errMsg.payoutData = res.body.message;
            } else {
              errMsg.payoutData = "Error loading payout data";
            }
            
            this.setState({
              errMsgPayout: errMsg,
            });
          }
          
          this.setState({
            payoutsRecord: payoutsRecord,
          });
        })
        .catch((err) => {
          // console.error("Failed to fetch payout data:", err);
          let payoutsRecord = this.state.payoutsRecord;
          payoutsRecord.loading = false;
          
          let errMsg = this.state.errMsgPayout;
          errMsg.payoutData = "Failed to load payout data. Please try again.";
          
          this.setState({
            payoutsRecord: payoutsRecord,
            errMsgPayout: errMsg,
          });
        });
    };

    const RenderPayoutData = () => {
      const payoutsRecord = this.state.payoutsRecord;
      const list = payoutsRecord.data;
      const hasMore = payoutsRecord.hasMore;
      const loading = payoutsRecord.loading;
      const RenderMoreBtn = () => {
        if (!hasMore) return false;
        return (
          <div className="OrgPayout-moreBtn" onClick={clickPayoutDateBtn}>
            {textObj.moreBtn}
          </div>
        );
      };

      if (loading || this.state.loading) {
        return (
          <div className="OrgPayout-gridBG">
            <div className="OrgPayout-gridContainer">
              <div className="OrgPayout-gridItem">Loading</div>
            </div>
          </div>
        );
      }

      const payoutDataErr = this.state.errMsgPayout.payoutData;
      if (payoutDataErr) {
        return (
          <div className="OrgPayout-gridBG">
            <div className="OrgPayout-gridContainer">
              <div className="OrgPayout-gridItem">{payoutDataErr}</div>
            </div>
          </div>
        );
      }

      if (list.length < 1) {
        return false;
      }

      return <div><PayoutHistoryTable list={list} textObj={textObj} language={this.props.language} /><RenderMoreBtn /></div>;
    };

    const RenderSelectBack = () => {
      if (this.props.orgID === 18 || this.state.blocked) {
        //blocked rendering
        return (
          <div className="OrgPayout-block">
            <div className="OrgPayout-blockContainer">
              <div className="OrgPayout-blockLogo" />
              <div className="OrgPayout-blockTxt">
                Please reach out to CheckPlus if you would like to update bank
                information.
              </div>
            </div>
          </div>
        );
      }
      return (
        <div>
          <div className="OrgPayout-heading">{textObj.heading[0]}</div>
          <div className="OrgPayout-subheading">{textObj.subheading}</div>

          <Link to="/OrgBankAdd">
            <div className="OrgPayout-addframe">
              <div className="OrgPayout-addIcn" />
            </div>
          </Link>

          <div className="OrgPayout-scrollContainer">
            <div className="OrgPayout-space" />

            {this.state.bankAc.map((ac) => renderOrgBankAc(ac))}

            <div className="OrgPayout-space" />
          </div>
          <div className="OrgPayout-subtitle">
            {renderErrorMsg(this.state.errMsgPayout.selecAc)}
          </div>
        </div>
      );
    };

    const RenderPayoutInput = () => {
      if (this.state.bankAc.length < 1) return null;
      return (
        <div className="OrgPayout-requestPayout">
          <div className="OrgPayout-heading">{textObj.heading[1]}</div>
          <div className="OrgPayout-subtitle">
            {textObj.subtitle[0]} : HK${this.state.balance}
          </div>
          <div className="OrgPayout-inputFieldContainer">
            <div className="OrgPayout-dollarSign">HK$</div>
            <NumericFormat
              className="OrgPayout-inputField"
              valueIsNumericString={true}
              value={this.state.payoutAmount}
              onChange={_payoutInput}
              allowNegative={false}
              thousandSeparator={true}
            />
            <div className="OrgPayout-nextBtn" onClick={submitBtn} />
          </div>
          <div className="OrgPayout-subtitle">
            {renderErrorMsg(this.state.errMsgPayout.amount)}
          </div>
        </div>
      );
    };

    return (
      <div className="OrgPayout-contentContainer">
        <div className="OrgPayout-contentHeader">
          <div className="OrgPayout-info">{textObj.info}</div>
          {this.state.kyc > 0 ? (
            <a
              href={this.state.stripeAccountLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div
                className="OrgInfo-badKycContainer"
                style={{ color: "white" }}
              >
                <div className="OrgInfo-badKyc" />
              </div>
            </a>
          ) : (
            <a href={this.state.stripeAccountLink} rel="noopener noreferrer">
              <div
                className="OrgInfo-goodKycContainer"
                style={{ color: "white" }}
              >
                <div className="OrgInfo-goodKyc" />
              </div>
            </a>
          )}
        </div>

        <div className="OrgPayout-content">
          {/* Stripe Link Toggle */}
          <div style={{
            padding: '20px',
            marginBottom: '20px',
            backgroundColor: '#f8f9fa',
            border: '1px solid #e9ecef'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <div>
                <div style={{ fontWeight: '600', marginBottom: '4px' }}>
                  {textObj.stripeLink ? textObj.stripeLink[0] : 'Enable Link by Stripe'}
                </div>
                <div style={{ fontSize: '13px', color: '#6c757d' }}>
                  {textObj.stripeLink ? textObj.stripeLink[1] : 'Allow users to use Link by Stripe for faster checkout'}
                </div>
              </div>
              <ToggleSwitch
                checked={this.props.enableStripeLink}
                onChange={this.props.onToggleEnableStripeLink}
                disabled={this.props.loading}
              />
            </div>
          </div>

          {this.state.cardPaymentsStatus === "unrequested" &&
          this.state.transfersStatus === "unrequested" ? (
              <div className="OrgPayout-activate3DS">
                <div className="OrgPayout-activate3DSInnerContainer">
                  <div className="OrgPayout-3DSHeading">
                    {textObj.threeDSecure[0]}
                  </div>
                  <div className="OrgPayout-3DSDetails">
                    {textObj.threeDSecure[1]}
                  </div>
                  <div className="OrgPayout-3DSBtn" onClick={activate3DS}>
                    <div className="OrgPayout-3DSBtnTxt">
                      {textObj.threeDSecure[2]}
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          <RenderSelectBack />
          <RenderPayoutInput />
          <section className="OrgPayout-historySection" aria-label={textObj.heading[2]}>
            <div className="OrgPayout-heading">{textObj.heading[2]}</div>
            <div className="OrgPayout-subtitle">{textObj.subtitle[1]}</div>

            <div className="OrgPayout-reportInputFieldContainer">
              <div className="OrgPayout-leftDate">
                <div className="OrgPayout-reportInputField">
                  <DatePicker
                    selected={this.state.startDate}
                    selectsStart
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    maxDate={this.state.endDate}
                    className="OrgPayout-datePicker"
                    onChange={handleChange.bind(this, "startDate")}
                    dateFormat="yyyy/MM/dd"
                  />
                </div>
              </div>

              <div className="OrgPayout-middleDate">-</div>

              <div className="OrgPayout-rightDate">
                <div className="OrgPayout-reportInputField">
                  <div className="OrgBalanceReports-inputField">
                    <DatePicker
                      maxDate={new Date()}
                      selected={this.state.endDate}
                      selectsEnd
                      startDate={this.state.startDate}
                      endDate={this.state.endDate}
                      className="OrgPayout-datePicker"
                      onChange={handleChange.bind(this, "endDate")}
                      dateFormat="yyyy/MM/dd"
                    />
                  </div>
                </div>
              </div>
              <button type="button" className="OrgPayout-dateBtn" aria-label="Load payout history" onClick={clickPayoutDateBtn} />
            </div>

            {RenderPayoutData()}
          </section>

          <div className="OrgPayout-footer" />
        </div>
      </div>
    );
  }
}

RenderStripe.propTypes = {
  language: PropTypes.string,
  languageObj: PropTypes.object,
  orgID: PropTypes.number,
  enableStripeLink: PropTypes.bool,
  onToggleEnableStripeLink: PropTypes.func,
  loading: PropTypes.bool,
};

export default RenderStripe;
